import { UIStyles } from '../../theme'
import styled, { css } from 'styled-components'
import React from 'react'
import withTranslator from '../HOCComponents/withTranslator'
import { StyledTooltip } from './StyledTooltip'

// Modal close buttons: a soft white cross on a faint round backdrop that turns red under the pointer.
export const closeButtonLook = css`
  background-color: ${UIStyles.whiteTransparent01};
  color: ${UIStyles.whiteTransparent08};
  border-radius: 50%;
  transition: color 0.15s, background-color 0.15s;
  &:hover {
    background-color: ${UIStyles.redColor};
    color: ${UIStyles.whiteColor};
  }
`

const CloseModalButton = styled.button`
  ${closeButtonLook}
  border: none;
  font-size: 1.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0;
  padding: 0;
  height: 2.2rem;
  width: 2.2rem;
  i.fas {
    width: auto;
    height: auto;
  }
`

export default withTranslator(props => (
  <StyledTooltip title={props.t('Close')} placement="top">
    <CloseModalButton {...props}>
      <i className="fas fa-times" />
    </CloseModalButton>
  </StyledTooltip>
))
